import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// 03311113255
// Hassan tahir
const root = createRoot(document.getElementById('root'));
root.render(<App />);
